export var UserAccess;
(function (UserAccess) {
    UserAccess["None"] = "NONE";
    UserAccess["Regular"] = "REGULAR";
    UserAccess["Admin"] = "ADMIN";
})(UserAccess || (UserAccess = {}));
